import { axiosPost, axiosDelete } from '@/utils/httpUtil'
import { API_URL } from '@/utils/constant/app.constants'

/**
 * @description: httpSuppMoDlMrDlvyJoinRetrieveUserDupCheck (배달기사 아이디 중복체크 조회)
 * @param {string} userId 사용자ID
 */
export const httpSuppMoDlMrDlvyJoinRetrieveUserDupCheck = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-join/retrieve-user-dup-check',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo (배달기사 로그인 정보 조회)
 * @param {string} joinCd 가입코드
 */
export const httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-join/retrieve-dlvy-login-info',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyJoinRetrieveJoinCdDupCheck (배달기사 가입코드 중복확인 조회)
 * @param {string} joinCd 가입코드
 */
export const httpSuppMoDlMrDlvyJoinRetrieveJoinCdDupCheck = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-join/retrieve-join-cd-dup-check',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyJoinCreateDlvyJoin (배달기사 회원가입)
 * @param {string} userId 사용자ID
 * @param {string} loginPasswd 로그인비밀번호
 * @param {string} joinCertNo 가입인증번호
 * @param {string} riderCelphnNo 배달기사 핸드폰번호
 * @param {string} userNm 사용자명
 */
export const httpSuppMoDlMrDlvyJoinCreateDlvyJoin = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-join/create-dlvy-join',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyJoinUpdateUserId (배달기사 유저ID 저장)
 * @param {string} userId 사용자ID
 * @param {string} joinCd 가입코드
 */
export const httpSuppMoDlMrDlvyJoinUpdateUserId = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-join/update-user-id',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlLgLoginRetrieveUserInfo (사용자 정보 조회)
 */
export const httpSuppMoDlLgLoginRetrieveUserInfo = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/lg/login/retrieve-user-info',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlCmmDlvyCommUpdateDlvyPosit (배달기사 위치 저장)
 * @param {string} mapX 위도
 * @param {string} mapY 경도
 * @param {string} addr 주소
 * @param {string} joinCd 가입코드
 */
export const httpSuppMoDlCmmDlvyCommUpdateDlvyPosit = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/cmm/dlvy-comm/update-dlvy-posit',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlCmmDlvyCertCertCryptoCheck (핸드폰 인증 암호화)
 * @param {string} cpId 고객사ID(한국모바일인증에서 발급한 CP ID 정보)
 * @param {string} urlCode URL코드(서비스 호출 웹 페이지마다 등록 된 코드 정보, 회원가입:004001, 아이디찾기:004002, 비밀번호찾기:004003)
 * @param {string} certNum 요청번호(서비스 호출 시 Unique한 값)
 * @param {string} date 요청일시(요청년도+월+일+시+분+초, YYYYMMDDhhmmss)
 * @param {string} certMet 본인확인방법(M:휴대폰 본인확인)
 * @param {string} plusInfo 추가DATA정보(사용자ID)
 * @param {string} extendVar 확장변수 example: 0000000000000000
 */
export const httpSuppMoDlCmmDlvyCertCertCryptoCheck = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/cmm/dlvy-cert/cert-crypto-check',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlCmmDlvyCertCertDecrptCheck (핸드폰 인증 복호화)
 * @param {string} recCert 결과수신DATA
 * @param {string} certNum 요청번호
 */
export const httpSuppMoDlCmmDlvyCertCertDecrptCheck = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/cmm/dlvy-cert/cert-decrpt-check',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyWaitRetrieveSchRegPosbYn (스케줄 등록 가능 여부 조회)
 * @param {string} dlvySchedDt 배달예정일자
 */
export const httpSuppMoDlMrDlvyWaitRetrieveSchRegPosbYn = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-wait/retrieve-sch-reg-posb-yn',
    data: pdata
  })
}

/**
 * @description: httpSuppApiMoDlCmmDlvyCommRetrieveDlvyCnt (배송현황 건수 조회)
 * @param {string} dlvySchedDt 배달예정일자
 * @param {string} joinCd 가입코드
 * @param {string} qcOperYn QC운영여부(N:미운영,Y:운영)
 */
export const httpSuppApiMoDlCmmDlvyCommRetrieveDlvyCnt = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/cmm/dlvy-comm/retrieve-dlvy-cnt',
    data: pdata
  })
}

/**
 * @description: httpSuppApiMoDlMrDlvyWaitRetrieveDlvyRecpt (영수증 조회)
 * @param {string} dlvyDt 배달일자
 * @param {string} joinCd 가입코드
 * @param {string} dlvyAceptNo 배달접수번호
 */
export const httpSuppApiMoDlMrDlvyWaitRetrieveDlvyRecpt = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-wait/retrieve-dlvy-recpt',
    data: pdata
  })
}

/**
 * @description: httpSuppApiMoDlMrDlvyWaitRetrieveDlvyOrdList (배달 주문(대기) 조회)
 * @param {string} dlvySchedDt 배달예정일자
 * @param {string} joinCd 가입코드
 * @param {string} sortType 정렬방식(0:주소(가나다순), 1:배차요청시간)
 * @param {string} aceptSpCd 접수구분코드(일반배송:P,S 점포몰:I, 퀵커머스:Q, 사전예약:R)
 */
export const httpSuppApiMoDlMrDlvyWaitRetrieveDlvyOrdList = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-wait/retrieve-dlvy-ord-list',
    data: pdata
  })
}

/**
 * @description: httpSuppApiMoDlMrDlvyWaitSaveSchReg (스케줄 등록)
 * @param {string} dlvySchedDt 배달예정일자
 * @param {string} dlvyDt 배달일자
 * @param {string} dlvyAceptNo 배달접수번호
 * @param {string} schSeqno 순번(배차순서)
 */
export const httpSuppApiMoDlMrDlvyWaitSaveSchReg = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-wait/save-sch-reg',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyProgRetrieveDlvySchList (배송 스케줄 조회)
 * @param {string} dlvySchedDt 배달예정일자
 * @param {string} joinCd 가입코드
 * @param {string} sortType 정렬방식(0: 주소-가나다순 , 1:배송요청시간순차-오름차순)
 * @param {string} searchType 조회구분(0:전체 , 1:배송주문)
 * @param {string} aceptSpCd 접수구분코드(일반배송:P,S 점포몰:I, 퀵커머스:Q, 사전예약:R)
 * @param {string} ordStepCd 주문단계(0:대기,1:진행,2:완료,3:취소,S:출발)
 */
export const httpSuppMoDlMrDlvyProgRetrieveDlvySchList = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-prog/retrieve-dlvy-sch-list',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyProgUpdateDlvyOrdStepProc (배송 주문 단계 처리(진행,완료,미완료))
 * @param {string} dlvyDt 배달일자
 * @param {string} dlvySchedDt 배달예정일자
 * @param {string} dlvyAceptNo 배달접수번호
 * @param {string} seqno 순번(배차순서)
 * @param {string} attFileId 첨부파일ID
 * @param {string} saveFileNm 저장파일명
 * @param {string} imgYn 이미지 첨부여부(완료시: Y:첨부, N:미첨부)
 * @param {string} ordStepCd 주문단계(0:대기,1:진행-바코드스캔,2:완료,3:취소)
 * @param {string} chgOrdStepCd 변경주문단계(0:대기,1:진행-바코드스캔,2:완료,3:취소,S:출발)
 * @param {string} resnCode 사유코드(미완료)
 * @param {string} resnNm 사유명
 * @param {string} dvicSp 장비구분(0:WEB, 1:NATIVE)
 * @param {string} barcode 바코드(Native 일경우 필수)
 */
export const httpSuppMoDlMrDlvyProgUpdateDlvyOrdStepProc = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-prog/update-dlvy-ord-step-proc',
    data: pdata,
    useCustomMsg: true
  })
}

/**
 * @description: httpSuppMoDlMrDlvyProgUpdateDlvyAceptSendApiRslt (점포퀵커머스 API 전송 결과 업데이트)
 * @param {string} dlvyDt 배달일자
 * @param {string} dlvyAceptNo 배달접수번호
 * @param {string} ordId 주문ID
 */
export const httpSuppMoDlMrDlvyProgUpdateDlvyAceptSendApiRslt = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-prog/update-dlvy-acept-send-api-rslt',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyProgCreateDelayInforSend (지연 안내 발신)
 * @param {string} dlvyDt 배달일자
 * @param {string} dlvyAceptNo 배달접수번호
 */
export const httpSuppMoDlMrDlvyProgCreateDelayInforSend = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-prog/create-delay-infor-send',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyProgDeleteDlvySch (배송 스케줄 삭제)
 * @param {string} dlvyDt 배달일자
 * @param {string} dlvyAceptNo 배달접수번호
 */
export const httpSuppMoDlMrDlvyProgDeleteDlvySch = (pdata) => {
  return axiosDelete({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-prog/delete-dlvy-sch',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageRetrieveDlvyPastHistList (과거 배송 이력 조회)
 * @param {string} fromSchedDt 배달예정일자 (시작)
 * @param {string} toSchedDt 배달예정일자 (종료)
 * @param {string} sortType 정렬방식(0: 주소-가나다순 , 1:배송요청시간순차-오름차순)
 * @param {string} searchType 조회구분(0:전체 , 1:배송주문)
 * @param {string} aceptSpCd 접수구분코드(일반배송:P,S 점포몰:I, 퀵커머스:Q, 사전예약:R)
 * @param {string} ordStepCd 주문단계(0:대기,1:진행,2:완료,3:취소,S:출발)
 */
export const httpSuppMoDlMpMyPageRetrieveDlvyPastHistList = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/retrieve-dlvy-past-hist-list',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageCreateDlvyHandAcept (배송신청 (수기접수))
 * @param {string} hpNo 휴대폰번호
 * @param {string} aceptSpCd 구분: P:POS-일반, I:인터넷-점포몰, Q:퀵커머스, R:사전예약
 * @param {string} dlvyAddr 배달주소
 * @param {string} notes 기타사항
 * @param {string} absenceNotes 배송메시지
 */
export const httpSuppMoDlMpMyPageCreateDlvyHandAcept = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/create-dlvy-hand-acept',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageRetrieveDlvyNotice (공지사항 조회)
 * @param {string} regDate 등록일자
 * @param {string} infoMsg 안내문내용
 */
export const httpSuppMoDlMpMyPageRetrieveDlvyNotice = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/retrieve-dlvy-notice',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageRetrievePasswdCheck (현재 비밀번호 확인 조회)
 * @param {string} loginPasswd 로그인 비밀번호
 */
export const httpSuppMoDlMpMyPageRetrievePasswdCheck = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/retrieve-passwd-check',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageUpdateUserPasswd (비밀번호 변경)
 * @param {string} loginPasswd 로그인 비밀번호
 * @param {string} updatePasswd 신규 비밀번호
 */
export const httpSuppMoDlMpMyPageUpdateUserPasswd = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/update-user-passwd',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMpMyPageUpdateDlvySeqnoReset (배송 스케줄 리셋)
 */
export const httpSuppMoDlMpMyPageUpdateDlvySeqnoReset = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mp/my-page/update-dlvy-seqno-reset',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyFindIdRetrieveDlvyFindId (배달기사 아이디 찾기)
 * @param {string} riderCelphnNo 배달기사 핸드폰 번호
 */
export const httpSuppMoDlMrDlvyFindIdRetrieveDlvyFindId = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-find-id/retrieve-dlvy-find-id',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyFindPasswdRetrieveFindPasswdCheckId (배달기사 비밀번호 찾기 아이디 체크)
 * @param {string} userId 사용자ID
 * @param {string} riderCelphnNo 배달기사 핸드폰 번호
 */
export const httpSuppMoDlMrDlvyFindPasswdRetrieveFindPasswdCheckId = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-find-passwd/retrieve-find-passwd-check-id',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlMrDlvyFindPasswdUpdateDlvyUserPasswd (배달기사 비밀번호 변경)
 * @param {string} userId 사용자ID
 * @param {string} loginPasswd 로그인 비밀번호
 * @param {string} updatePasswd 신규 비밀번호
 */
export const httpSuppMoDlMrDlvyFindPasswdUpdateDlvyUserPasswd = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/mr/dlvy-find-passwd/update-dlvy-user-passwd',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlNtAlimtalkRetrieveDlvyDriverPosit (배달기사 기사 위치 조회 (고객용))
 * @param {string} userId 사용자ID
 * @param {string} loginPasswd 로그인 비밀번호
 * @param {string} updatePasswd 신규 비밀번호
 */
export const httpSuppMoDlNtAlimtalkRetrieveDlvyDriverPosit = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/nt/alimtalk/retrieve-dlvy-driver-posit',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlNtAlimtalkRetrieveDlvyImg (배송 사진 조회 (고객용))
 * @param {string} attFileId 첨부파일ID
 */
export const httpSuppMoDlNtAlimtalkRetrieveDlvyImg = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/nt/alimtalk/retrieve-dlvy-img',
    data: pdata
  })
}

/**
 * @description: httpSuppMoDlNtAlimtalkRetrieveDlvyRecpt (영수증 조회 (고객용))
 * @param {string} dlvyDt 배달일자
 * @param {string} strCd 점포코드
 * @param {string} dlvyAceptNo 배달접수번호
 */
export const httpSuppMoDlNtAlimtalkRetrieveDlvyRecpt = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/dl/nt/alimtalk/retrieve-dlvy-recpt',
    data: pdata
  })
}
